const NullComponent = () => null

export default NullComponent



// WEBPACK FOOTER //
// ./src/components/NullComponent.js